<template>
  <header id="header" class="fixed-top">
    <nav>
      <div class="nav-wrapper">

        <Drawer v-model:visible="sideBarIsOpenMobile" header=" ">
          <Sidebar :onLinkClick='hideSideBarMobile' :isOpen="true" class="sidebar-mobile" :class="{ collapsed: true }" />
        </Drawer>

        <div class="flex items-center gap-4 md:gap-0">
          <Button v-if="isMobile" icon="pi pi-bars" aria-label="Menu" severity="contrast" variant="text" rounded @click="showSideBarMobile" />
          <!-- <img src="@/assets/ginger-logo-64.svg" width="42" height="42" /> -->
        </div>

        <div class="flex items-center gap-4 md:gap-0">
          <user-menu />
        </div>
      </div>

    </nav>
  </header>
</template>

<script>
import Sidebar from "@/components/app/Sidebar";
import UserMenu from "@/components/app/UserMenu";
import { mapGetters } from 'vuex';
import Button from 'primevue/button';
import Drawer from 'primevue/drawer';

export default {
  computed: {
    ...mapGetters('ui', ['isMobile']),
  },
  data() {
    return {
      sideBarIsOpenMobile: false
    }
  },
  components: {
    Sidebar,
    Button,
    UserMenu,
    Drawer,
  },

  methods: {
    hideSideBarMobile() {
      this.sideBarIsOpenMobile = false; 
    },

    showSideBarMobile() {
      this.sideBarIsOpenMobile = true; 
    },
  },
};
</script>


<style scope lang="scss">

.sidebar-mobile {
  width: 100%!important;
}

.nav-wrapper {
  display: flex;
  height: var(--header-height);
  line-height: var(--header-height);
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  border-bottom: 1px solid var(--border-light);
  background-color: var(--primary-background-light)!important;
  padding: 8px 16px;
  overflow: visible;
}

.my-app-dark .nav-wrapper {
  border-bottom: 1px solid var(--border-dark);
   background-color: var(--primary-background-dark)!important;
}

.list-group {
  min-width: 100%;
}

.nav-item {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  height: 40px;
  gap: 8px;
  text-decoration: none;
  width: 100%;
  transition: background 0.3s ease;
  color: rgba(0,0,0,0.87);
  font-size: 14px;  
}

.nav-item:hover {
  background: var(--Theme-Primary, #FFE5D0);
  border-radius: var(--bs-border-radius);
}

.active-link {
  background-color: var(--Orange-100);
  border-radius: var(--bs-border-radius);
}

</style>
